import { ExamDifficulty } from "@brookbush/types";

import clsx from "clsx";

import { examDifficultyMap } from "~/utils/constants";

interface Props {
	finalExamDifficulty: ExamDifficulty;
	size?: "sm" | "md" | "lg";
	className?: string;
}

const CourseExamDifficulty = ({
	finalExamDifficulty,
	size = "md",
	className,
}: Props) => {
	const item = examDifficultyMap[finalExamDifficulty];

	if (!item) return null; // or handle the case where the difficulty is not found

	return (
		<div
			className={clsx("flex items-center", {
				"gap-1.5": size === "sm",
				"gap-2": size === "md" || size === "lg",
			})}
		>
			<div className="flex items-end gap-0.5">
				{Array(5)
					.fill(0)
					.map((_, index) => (
						<span
							key={index}
							style={{
								height:
									size === "sm"
										? `calc(${(index + 2) * 0.1}rem)`
										: size === "md"
											? `calc(${(index + 2) * 0.15}rem)`
											: `calc(${(index + 2) * 0.2}rem)`,

								width: size === "sm" ? `3px` : size === "md" ? `4px` : `5px`,
							}}
							className={clsx(
								`inline-block w-1 rounded-sm shadow-inner`,
								index < finalExamDifficulty
									? finalExamDifficulty === ExamDifficulty.VERY_EASY
										? "bg-sky-500 dark:bg-sky-400"
										: finalExamDifficulty === ExamDifficulty.EASY
											? "bg-sky-500 dark:bg-sky-400"
											: finalExamDifficulty === ExamDifficulty.MEDIUM
												? "bg-orange-500 dark:bg-orange-400"
												: finalExamDifficulty === ExamDifficulty.HARD
													? "bg-red-500 dark:bg-red-400"
													: "bg-purple-500 dark:bg-purple-400"
									: "bg-slate-300 dark:bg-slate-500",
							)}
						/>
					))}
			</div>

			<h2
				className={clsx(
					"font-semibold",
					size === "sm" ? "text-xs" : size === "md" ? "text-base" : "text-lg",
					className,
				)}
			>
				{item.title}
			</h2>
		</div>
	);
};

export default CourseExamDifficulty;
